import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditSummaryCards = ({ summaryData }) => {
  const cards = [
    {
      title: 'Consultas Totales',
      value: summaryData?.totalQueries?.toLocaleString('es-MX'),
      change: `+${summaryData?.totalQueriesChange}%`,
      changeType: summaryData?.totalQueriesChange >= 0 ? 'positive' : 'negative',
      icon: 'Search',
      color: 'blue'
    },
    {
      title: 'Tasa de Éxito',
      value: `${summaryData?.successRate}%`,
      change: `${summaryData?.successRateChange >= 0 ? '+' : ''}${summaryData?.successRateChange}%`,
      changeType: summaryData?.successRateChange >= 0 ? 'positive' : 'negative',
      icon: 'CheckCircle',
      color: 'green'
    },
    {
      title: 'Usuarios Activos',
      value: summaryData?.activeUsers?.toLocaleString('es-MX'),
      change: `${summaryData?.activeUsersChange >= 0 ? '+' : ''}${summaryData?.activeUsersChange}`,
      changeType: summaryData?.activeUsersChange >= 0 ? 'positive' : 'negative',
      icon: 'Users',
      color: 'purple'
    },
    {
      title: 'Latencia Promedio',
      value: `${summaryData?.avgLatency}ms`,
      change: `${summaryData?.avgLatencyChange >= 0 ? '+' : ''}${summaryData?.avgLatencyChange}ms`,
      changeType: summaryData?.avgLatencyChange <= 0 ? 'positive' : 'negative',
      icon: 'Clock',
      color: 'orange'
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'bg-blue-100 text-blue-600',
      green: 'bg-green-100 text-green-600',
      purple: 'bg-purple-100 text-purple-600',
      orange: 'bg-orange-100 text-orange-600'
    };
    return colorMap?.[color] || colorMap?.blue;
  };

  const getChangeColor = (changeType) => {
    return changeType === 'positive' ? 'text-green-600' : 'text-red-600';
  };

  const getChangeIcon = (changeType) => {
    return changeType === 'positive' ? 'TrendingUp' : 'TrendingDown';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {cards?.map((card, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 shadow-elevation">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${getColorClasses(card?.color)}`}>
              <Icon name={card?.icon} size={24} />
            </div>
            <div className={`flex items-center space-x-1 text-sm ${getChangeColor(card?.changeType)}`}>
              <Icon name={getChangeIcon(card?.changeType)} size={16} />
              <span className="font-medium">{card?.change}</span>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">{card?.value}</h3>
            <p className="text-sm text-muted-foreground">{card?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AuditSummaryCards;